import { Controller } from 'react-hook-form';

import './styles.css'; // Import CSS for styling and animation

interface ToggleButtonProps {
  control: any;
  label?: string;
  rules?: any;
  name: string;
  description?: string;
}

const ToggleButton = ({ control, label, rules, name, description } : ToggleButtonProps) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, value } }) => (
        <div className="flex flex-col gap-1">
          <label className="toggle-button inline-flex items-start cursor-pointer">
            <input type="checkbox" value="" className="sr-only peer" onChange={onChange} checked={value} />
            <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-500"></div>
            {label && (
              <div className="flex flex-col">
                <span className="ms-2 text-sm font-medium text-gray-900">{label}</span>
                {description && <span className="text-sm text-gray-900 ms-2">{description}</span>}
              </div>
            )}
          </label>
        </div>
      )}
    />
  );
};


export default ToggleButton;